import { formatCurrencyValue } from '@/modules/common/lib/formatters';
import { DeleteOutline, Edit } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useFormContext } from 'react-hook-form';
import { LearningBudgetSetupItemDirtyDot } from '../LearningBudgetSetupItemDirtyDot';
import { EmployeeRow } from '../LearningBudgetSetupsTable.types';

export const createColumns = (
  onEdit: (row: EmployeeRow) => void,
  onDelete: (row: EmployeeRow) => void,
): MRT_ColumnDef<EmployeeRow>[] => [
  {
    header: 'Employee',
    accessorKey: 'name',
    Cell: ({
      row: {
        original: { employee, budget, isDirty },
      },
    }) => (
      <Box className="flex items-center gap-1">
        <Typography className="pl-20" variant="body2" color="textPrimary">
          {[employee.firstName, employee.lastName].filter(Boolean).join(' ')}:{' '}
          {formatCurrencyValue(budget.amount, budget.currency)}
        </Typography>
        <LearningBudgetSetupItemDirtyDot isDirty={isDirty} />
      </Box>
    ),
    muiTableBodyCellProps: ({ table }) => ({
      ...table.options.muiTableBodyCellProps,
      classes: {
        // @ts-expect-error - TODO: fix this
        root: `pl-0 ${table.options.muiTableBodyCellProps?.classes?.root}`,
      },
    }),
  },
  {
    header: 'Actions',
    Cell: ({ row }) => {
      const {
        formState: { isSubmitting, disabled },
      } = useFormContext();

      return (
        <div className="flex gap-2">
          <Button
            size="small"
            variant="text"
            startIcon={<DeleteOutline />}
            color="error"
            className="bg-white"
            disabled={disabled || isSubmitting}
            onClick={() => onDelete(row.original)}
          >
            Delete
          </Button>
          <Button
            size="small"
            variant="text"
            startIcon={<Edit />}
            className="bg-white -mr-4"
            onClick={() => onEdit(row.original)}
            disabled={disabled || isSubmitting}
          >
            Edit
          </Button>
        </div>
      );
    },
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
  },
];
